import { api } from "@/lib/api";
import { pushSupported, registerServiceWorker } from "@/lib/push";

const toKey = (base64) => {
  const b64 = (base64 + "=".repeat((4 - (base64.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/");
  return Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
};

export const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export async function mobilePushStatus() {
  if (!pushSupported()) return { supported: false, permission: "unsupported", subscribed: false };
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  return { supported: true, permission: Notification.permission, subscribed: !!sub };
}

export async function enableMobilePush() {
  if (!pushSupported()) {
    throw new Error(isIOS() && !isStandalone()
      ? "En iPhone primero instala la app: Compartir → Agregar a pantalla de inicio"
      : "Este navegador no soporta notificaciones push");
  }
  if ((await Notification.requestPermission()) !== "granted") throw new Error("Debes permitir las notificaciones");
  const reg = (await registerServiceWorker()) || (await navigator.serviceWorker.ready);
  const { data } = await api.get("/mobile/push/key");
  if (!data.key) throw new Error("Notificaciones no configuradas en el servidor");
  const sub = (await reg.pushManager.getSubscription()) ||
    (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(data.key) }));
  await api.post("/mobile/push/subscribe", { subscription: sub.toJSON(), device: navigator.userAgent });
  return true;
}

export async function disableMobilePush() {
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && (await reg.pushManager.getSubscription());
  if (!sub) return;
  try { await api.post("/mobile/push/unsubscribe", { subscription: sub.toJSON() }); } catch (_) { /* sin red */ }
  await sub.unsubscribe();
}
